var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { styled } from '@a0/quantum-product';
import * as React from 'react';
import { ApiFeedback, useApiFeedback } from '../../ApiFeedback';
import { ContentStyler } from '../../ContentRenderer';
import { OverlaySpinner } from '../../Spinner';
var httpMethodBadgeSelector = function (method) {
    return "& .swagger-section .swagger-ui-wrap ul#resources li.resource ul.endpoints li.endpoint ul.operations li.operation.".concat(method, " div.heading h3 span.http_method a");
};
var ManagementApiContent = styled(ContentStyler)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            '& .swagger-section h2.operation-title': __assign({}, theme.typography.h2),
            '& ul > li': {
                listStyleType: 'none',
            },
            '& .form-control:focus': {
                borderColor: theme.palette.primary.light,
                boxShadow: "inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px ".concat(theme.palette.primary.light),
            },
            '& .btn-primary': {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.main,
                '&:hover': {
                    textDecoration: 'none',
                    backgroundColor: theme.palette.primary.dark,
                },
                '&:active': {
                    backgroundColor: theme.palette.primary.dark,
                },
            },
            '& .action-summary > code, .main-section .action-summary > code': __assign({}, theme.typography.code1),
            '& .swagger-section .sandbox_header a': {
                textDecoration: 'none',
                '&:hover': {
                    textDecoration: 'underline',
                },
            }
        },
        _b[httpMethodBadgeSelector('get')] = {
            backgroundColor: theme.palette.primary.light,
        },
        _b[httpMethodBadgeSelector('post')] = {
            backgroundColor: theme.palette.success.main,
        },
        _b[httpMethodBadgeSelector('put')] = {
            backgroundColor: theme.palette.info.main,
        },
        _b[httpMethodBadgeSelector('patch')] = {
            backgroundColor: theme.palette.warning.main,
        },
        _b[httpMethodBadgeSelector('delete')] = {
            backgroundColor: theme.palette.error.main,
        },
        _b['& .swagger-section .endpoint'] = {
            marginBottom: 0,
        },
        _b['& .feedback-container'] = {
            width: 'min-content',
            whiteSpace: 'nowrap',
            padding: theme.spacing(0, 0, 3, 3),
            marginTop: theme.spacing(4),
            cursor: 'pointer',
            // Compensate for missing ssr style
            '& .MuiButton-textSizeSmall': {
                padding: theme.spacing(0, 1),
            },
        },
        _b);
});
export var StaticPage = function (_a) {
    var _b = _a.content, content = _b === void 0 ? {} : _b;
    var _c = __read(React.useState(true), 2), loading = _c[0], setLoading = _c[1];
    var _d = useApiFeedback(), feedbackContainer = _d.feedbackContainer, renderFeedback = _d.renderFeedback, feedbackHTML = _d.feedbackHTML;
    React.useEffect(function () {
        if (!feedbackHTML) {
            return;
        }
        function onExplorerMutation(mutations) {
            try {
                mutations.forEach(function (m) {
                    __spreadArray([], __read(m.addedNodes), false).filter(function (node) { return node.nodeName === 'LI' && node.className.includes('resource'); })
                        .forEach(function (epNode) {
                        var endpointNotes = epNode.querySelectorAll('.endpoint');
                        endpointNotes.forEach(function (epNode) {
                            var operationNode = epNode.querySelector('.operation');
                            var div = document.createElement('div');
                            div.className = 'feedback-container';
                            div.setAttribute('data-feedback-operation', (operationNode === null || operationNode === void 0 ? void 0 : operationNode.id) || '');
                            div.addEventListener('mouseenter', renderFeedback);
                            div.innerHTML = feedbackHTML;
                            var contentNode = operationNode === null || operationNode === void 0 ? void 0 : operationNode.querySelector('.content');
                            if (contentNode) {
                                contentNode.appendChild(div);
                            }
                            else {
                                epNode.appendChild(div);
                            }
                        });
                    });
                });
            }
            catch (e) {
                console.error(e, 'Mutation failed');
            }
        }
        // Big time scroll hack because swaggerUI jQuery logic is terrible
        var hashScroll = document.location.hash.replace('#!/', '').replace('/', '_');
        if (hashScroll) {
            window.addEventListener('scroll', function (e) {
                setTimeout(function () {
                    var _a;
                    (_a = document.getElementById(hashScroll)) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                    //nudge it a little bit to trigger the right TOC item highlight
                    window.scrollBy(0, 10);
                }, 100);
                return false;
            }, { once: true });
        }
        try {
            var explorerMutation = new MutationObserver(onExplorerMutation);
            var swaggerUIContainer = document.getElementById('swagger-section');
            if (!swaggerUIContainer) {
                return;
            }
            explorerMutation.observe(swaggerUIContainer, {
                childList: true,
                subtree: true,
            });
        }
        catch (_a) {
            console.error('Mutation failed');
        }
    }, [feedbackHTML]);
    React.useEffect(function () {
        // If the document's content hasn't been loaded yet, display a spinner.
        if (content.html && content.meta) {
            setLoading(false);
        }
    }, [content]);
    var classes = ['content'];
    if (content.meta)
        classes = classes.concat(content.meta.classes);
    return (React.createElement(React.Fragment, null,
        loading && React.createElement(OverlaySpinner, null),
        React.createElement(ManagementApiContent, null,
            React.createElement("section", { id: "swagger-section", className: classes.join(' '), "data-swiftype-name": "body", "data-swiftype-type": "text", "data-swiftype-index": "true", dangerouslySetInnerHTML: { __html: content.html } })),
        feedbackContainer && React.createElement(ApiFeedback, { trackingCode: "docs:management-api", container: feedbackContainer })));
};
